import { createDecorator } from '../../instantiation/common/instantiation.js';
const IEditSessionIdentityService = ( createDecorator('editSessionIdentityService'));
export { IEditSessionIdentityService };
